module.exports = __webpack_public_path__ + "img/logo-beeldmerk.1f9af873.png";